import { render } from "./NewVirementPage.vue?vue&type=template&id=75b60699&ts=true"
import script from "./NewVirementPage.vue?vue&type=script&lang=ts"
export * from "./NewVirementPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__